// NOTE: Just add to your button class open-zendesk
export function init(zendeskKey) {
  if (zendeskKey) {
    addZenDeskScript(`https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`, () => {
      window.zESettings = {
        webWidget: {
          color: { theme: '#436db5' },
        },
      };
      zE('webWidget', 'hide');

      showSupportBtn();

      onClickSupportBtn(() => {
        zE('webWidget', 'show');
        zE('webWidget', 'open');
        const $menu = document.querySelector('.menu');
        $menu.classList.add('menu_hidden');
      });

      zE('webWidget:on', 'close', () => {
        zE('webWidget', 'hide');
      });
    });
  }

  function addZenDeskScript(src, cb) {
    const $script = document.createElement('script');
    $script.setAttribute('id', 'ze-snippet');
    $script.setAttribute('src', src);
    $script.addEventListener('load', cb);
    document.body.appendChild($script);
  }

  function showSupportBtn() {
    const $openSupportBtn = document.querySelector('.open-zendesk');
    $openSupportBtn.style.display = 'inline-flex';
  }

  function onClickSupportBtn(cb) {
    const $openSupportBtn = document.querySelector('.open-zendesk');
    $openSupportBtn.addEventListener('click', cb);
  }
}
